export { default } from 'styled-up/dist/SwitchInput';
